/* MapleWeld - Featured Offers slider: arrows, progress bar, gentle autoplay. */
(function () {
  'use strict';
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var track = root.querySelector('[data-mwo-track]'),
        prev = root.querySelector('[data-mwo-prev]'),
        next = root.querySelector('[data-mwo-next]'),
        bar = root.querySelector('[data-mwo-bar]');
    if (!track) return;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000,
        auto = root.hasAttribute('data-auto') && !calm,
        timer = null, held = false, inView = false, raf = 0;

    function card() { return track.querySelector('.mwh-card'); }
    function stepW() {
      var c = card(); if (!c) return track.clientWidth * 0.9;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return c.getBoundingClientRect().width + gap;
    }
    function maxX() { return track.scrollWidth - track.clientWidth; }
    function paint() {
      raf = 0;
      var m = maxX(), x = track.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= m - 2;
      if (bar) bar.style.transform = 'scaleX(' + (m > 0 ? Math.max(0.1, x / m) : 1) + ')';
    }
    function go(cards) {
      track.scrollTo({ left: Math.max(0, Math.min(maxX(), track.scrollLeft + cards * stepW())), behavior: calm ? 'auto' : 'smooth' });
    }
    function page() { return Math.max(1, Math.floor(track.clientWidth / stepW())); }

    function tick() {
      if (held || !inView || document.hidden) return;
      if (track.scrollLeft >= maxX() - 4) track.scrollTo({ left: 0, behavior: calm ? 'auto' : 'smooth' });
      else go(1);
    }
    function start() { stop(); if (auto && maxX() > 4) timer = setInterval(tick, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(-page()); start(); });
    if (next) next.addEventListener('click', function () { go(page()); start(); });
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', function () { paint(); start(); });

    /* pause while a visitor is looking at or touching the row */
    root.addEventListener('mouseenter', function () { held = true; });
    root.addEventListener('mouseleave', function () { held = false; });
    root.addEventListener('focusin', function () { held = true; });
    root.addEventListener('focusout', function () { held = false; });
    root.addEventListener('touchstart', function () { held = true; }, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(function () { held = false; }, 6000); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
    } else { inView = true; }

    paint(); start();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mwo]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();